export const contactDetails = {
  phoneNumber: {
    code: '+44',
    number: '75637 56808'
  },
  email: 'info@mapagardendesigns.co.uk',
  location: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11161.154079313046!2d-0.1427372281443799!3d51.502702803732454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c38c8cd1d9%3A0xb78f2474b9a45aa9!2sBig%20Ben!5e0!3m2!1sen!2sin!4v1755681849647!5m2!1sen!2sin',
  social: {
    instagram: {
      link: 'https://www.instagram.com/mapagardendesigns',
      hashtag: 'mapagardendesigns'
    },
  },
  website: 'https://www.mapagardendesigns.co.uk'
} as const;